module.exports = __webpack_public_path__ + "img/breath_red@2x.492cc93b.png";